import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { useAuth } from '@/features/auth';
import {
  createClienteComentario,
  listClienteComentarios,
  type ClienteComentario,
} from '../services/clienteComentarios.service';

export function useClienteComentarios(clienteId?: string, enabled = true) {
  const { profile } = useAuth();
  const queryClient = useQueryClient();
  const tenantId = profile?.tenant_id != null ? Number(profile.tenant_id) : null;

  const queryKey = ['cliente-comentarios', clienteId, tenantId];

  const { data: comentarios = [], isLoading, error, refetch } = useQuery({
    queryKey,
    queryFn: () => listClienteComentarios(clienteId!, tenantId!),
    enabled: enabled && !!clienteId && tenantId != null,
    staleTime: 1000 * 30,
  });

  const createMutation = useMutation({
    mutationFn: async ({
      conteudo,
      cardId,
    }: {
      conteudo: string;
      cardId?: string;
    }) => {
      if (!clienteId || !profile?.uuid || tenantId == null) {
        throw new Error('Cliente ou usuário não identificado');
      }
      return createClienteComentario({
        tenantId,
        clienteId,
        cardId,
        autorId: profile.uuid,
        conteudo,
      });
    },
    onSuccess: (novo: ClienteComentario) => {
      queryClient.setQueryData<ClienteComentario[]>(queryKey, (prev = []) => [novo, ...prev]);
    },
  });

  return {
    comentarios,
    loading: isLoading,
    error: error as Error | null,
    saving: createMutation.isPending,
    addComentario: createMutation.mutateAsync,
    refetch,
  };
}
